import React, { useState } from 'react';
import './header.css';
import logo from '../../Assets/Images/frota-logo.webp';
import { Link, useLocation } from 'react-router-dom';
import AdminNavLinks from './AdminNavLinks';
import UserNavLinks from './UserNavLinks';

const Header = ({ userRole }) => {
    const location = useLocation();
    const currentUrl = location.pathname;

    const [isNavCollapsed, setIsNavCollapsed] = useState(true);

    const handleNavCollapse = () => setIsNavCollapsed(!isNavCollapsed);

    return (
        <nav className="navbar navbar-expand-lg navbar-light">
            <Link className="navbar-brand" to={'/'} href="#">
                <img src={logo} height="72" alt="" />
            </Link>
            {currentUrl !== '/' && currentUrl !== '/admin-login' && currentUrl !== '/forgot-password' && currentUrl !== '/reset-password' ? (
                <>
                    <button className="navbar-toggler" type="button" data-toggle="collapse"
                        data-target="#navbarNav" aria-controls="navbarNav" aria-expanded={!isNavCollapsed ? true : false}
                        aria-label="Toggle navigation" onClick={handleNavCollapse}>
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className={`${isNavCollapsed ? 'collapse' : ''} navbar-collapse`} id="navbarNav">
                        <ul className="navbar-nav ml-auto">
                            <>
                                {userRole === 'admin' ?
                                    (<AdminNavLinks onClick={handleNavCollapse} />)
                                    : (<UserNavLinks onClick={handleNavCollapse} userRole={userRole} />)
                                }
                            </>
                        </ul>
                    </div>
                </>

            ) : (
                <>
                    {/* {currentUrl === '/' && (
                        <li className="nav-item" style={{ listStyle: 'none' }}>
                            <Link to={'/admin-login'} className="nav-link login-nav-link">LOGIN AS ADMIN</Link>
                        </li>
                    )}
                    {currentUrl === '/admin-login' && (
                        <li className="nav-item" style={{ listStyle: 'none' }}>
                            <Link to={'/'} className="nav-link login-nav-link">LOGIN AS USER</Link>
                        </li>
                    )} */}
                    {currentUrl === '/forgot-password' && (
                        <li className="nav-item" style={{ listStyle: 'none' }}>
                            <Link to={'/'} className="nav-link login-nav-link">BACK TO LOGIN</Link>
                        </li>
                    )}
                    {currentUrl === '/reset-password' && (
                        <li className="nav-item" style={{ listStyle: 'none' }}>
                            <Link to={'/'} className="nav-link login-nav-link">BACK TO LOGIN</Link>
                        </li>
                    )}
                </>
            )}
        </nav>
    );
};

export default Header;
